import { Injectable } from '@angular/core';
import { filter, Observable, tap } from 'rxjs';

import { AlarmStatusEnum, AlarmTypeEnum } from '@app/api/alarm/dtos';

import { AuthService } from '../auth/services/auth.service';
import { WsClient } from './ws-client';

export interface WsAlarmMessage {
  key: string;
  type: AlarmTypeEnum;
  time: number;
  userID?: string;
  userName?: string;
  devID: string;
  devName: string;
  subDevIdx?: number;
  status: AlarmStatusEnum;
  desc?: string;
  lat?: number;
  lng?: number;
  payload?: string;
}

@Injectable({
  providedIn: 'root',
})
export class WsAlarmService {
  private readonly ws = new WsClient<WsAlarmMessage>();

  public get message$(): Observable<WsAlarmMessage> {
    return this.ws.message$.pipe(filter(Boolean));
  }

  constructor(private readonly authService: AuthService) {
    this.authService.token$.pipe(tap((token) => this.handleTokenChanged(token))).subscribe();
  }

  protected handleTokenChanged(token: string | null): void {
    if (token) {
      this.ws.connect('/bvcsp/v1/ws/event/alarm', token);
    } else {
      this.ws.disconnect();
    }
  }
}
